import useProject from './useProject';

export const canEditProjectSelector = project => project?.canEdit;

export default function useCanEditProject() {
  return useProject({}, { select: canEditProjectSelector });
}
